import { useToast } from '@app/core/notifications';
import { socialExport } from '@mi-front/api-clients';
import { useIntl } from 'react-intl';
import { publishCardMessages } from '../publish-messages';

type Params = {
  onDeleteSuccess: (uploadId: string) => Promise<void>;
  onPromoteSuccess: (uploadId: string) => Promise<void>;
};

/**
 * Delete and promote mutations for a social upload card, with toast notifications.
 */
export function useUploadCardMutations({ onDeleteSuccess, onPromoteSuccess }: Params) {
  const { $t } = useIntl();
  const { notifySuccess, notifyError } = useToast();

  const deleteMutation = socialExport.useDeleteUpload({
    mutation: {
      onSuccess: async (_: socialExport.DeleteUpload200, variables: { id: string }) => {
        await onDeleteSuccess(variables.id);
        notifySuccess($t(publishCardMessages.videoDeletedFromPlatform));
      },
      onError: (error: Error) => {
        notifyError(error?.message || $t(publishCardMessages.errorDeletingVideo));
      },
    },
  });

  const promoteMutation = socialExport.usePromoteUpload({
    mutation: {
      onSuccess: async (_: socialExport.PromoteUpload200, variables: { id: string }) => {
        await onPromoteSuccess(variables.id);
        notifySuccess($t(publishCardMessages.publicationStarted));
      },
      onError: (error: Error) => {
        notifyError(error?.message || $t(publishCardMessages.errorPublishingNow));
      },
    },
  });

  return { deleteMutation, promoteMutation };
}
